module.exports = __webpack_public_path__ + "static/media/persona-small.28137150.png";